(() => {
  const init = (scope = document) => {
    const root = document.querySelector('[data-bp-unified-product]');
    if (!root) return;
    const payment = root.querySelector('.bp-accessory-main__purchase > .bp-product-payments');
    const dialog = root.querySelector('.bp-order-dialog__content');
    if (payment && dialog && !dialog.querySelector('.bp-product-payments')) dialog.append(payment.cloneNode(true));
    scope.querySelectorAll('.bp-accessory-related__products').forEach((track) => {
      if (track.dataset.bpUnifiedCarousel) return;
      track.dataset.bpUnifiedCarousel = 'true';
      const nav = document.createElement('div');
      nav.className = 'bp-unified-carousel-nav';
      const previous = document.createElement('button');
      const next = document.createElement('button');
      previous.type = next.type = 'button';
      previous.setAttribute('aria-label', root.dataset.previousLabel);
      next.setAttribute('aria-label', root.dataset.nextLabel);
      previous.textContent = '←';
      next.textContent = '→';
      nav.append(previous, next);
      track.before(nav);
      const sync = () => {
        nav.hidden = track.scrollWidth <= track.clientWidth + 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = (direction) => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({left: direction * ((card?.getBoundingClientRect().width || track.clientWidth) + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', sync, {passive:true});
      const resize = new ResizeObserver(sync);
      resize.observe(track);
      sync();
      const unload = (event) => {
        if (!event.target.contains(track)) return;
        resize.disconnect();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
